module.exports = __webpack_public_path__ + "components/rewards/absolutely-snow/static/logo-cb1987587d7b40ef66b4ef67ea16bd37.webp";